'use client';

import Link from "next/link";
import { TopicListItem } from "@/libs/topics";

const formatDateTime = (value: string | Date | null) => value
  ? new Intl.DateTimeFormat("uk-UA", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(value))
  : "Час невідомий";

export const TopicCardClient = ({ topic }: { topic: TopicListItem }) => {
  return (
    <Link
      href={`/topic/${topic.topicId}`}
      className="rounded-xl border border-default-200 bg-background/60 p-5 transition-colors hover:bg-default-100/50"
    >
      <div className="flex flex-col gap-2">
        <h2 className="text-2xl font-semibold">{topic.title}</h2>
        <p className="text-sm text-default-500">
          {topic.sourceCount} джерел • {topic.articleCount} матеріалів • оновлено {formatDateTime(topic.lastUpdated)}
        </p>
        <p className="text-default-600">{topic.previewText}</p>
      </div>
    </Link>
  );
};
